import { isLocalSqliteDirty } from '@src/modules/platform/local-sqlite/infrastructure/localSqlitePersistDirty.ts';
import { notifyLocalSqlitePersistError } from '@src/modules/platform/local-sqlite/infrastructure/localSqlitePersistError.ts';

let bound = false;
let flushFn: (() => Promise<void>) | undefined;

function runUnloadFlush(): void {
  if (!isLocalSqliteDirty() || !flushFn) return;
  void flushFn().catch((err) => {
    notifyLocalSqlitePersistError(err);
  });
}

function onVisibilityChange(): void {
  if (document.visibilityState === 'hidden') runUnloadFlush();
}

/** Flush IndexedDB snapshot when the tab hides if there are unsaved in-memory writes. */
export function bindLocalSqliteUnloadFlush(flush: () => Promise<void>): void {
  if (bound || typeof document === 'undefined') return;
  flushFn = flush;
  document.addEventListener('visibilitychange', onVisibilityChange);
  globalThis.addEventListener('pagehide', runUnloadFlush);
  bound = true;
}

export function resetLocalSqliteUnloadFlushForTests(): void {
  if (!bound || typeof document === 'undefined') return;
  document.removeEventListener('visibilitychange', onVisibilityChange);
  globalThis.removeEventListener('pagehide', runUnloadFlush);
  bound = false;
  flushFn = undefined;
}
